import React from 'react';
import { Sparkles } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
export function Hero() {
  return <SectionWrapper bg="cream" className="relative overflow-hidden pt-20 md:pt-32 pb-16 md:pb-24" data-id="element-82">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-blush rounded-full blur-3xl opacity-50 -z-10 pointer-events-none" data-id="element-83"></div>

      <div className="text-center max-w-3xl mx-auto flex flex-col items-center" data-id="element-84">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-blush shadow-sm mb-8" data-id="element-85">
          <Sparkles className="w-4 h-4 text-gold" data-id="element-86" />
          <span className="text-sm font-semibold text-warm-muted uppercase tracking-wider" data-id="element-87">
            Programa Profesional
          </span>
          <Sparkles className="w-4 h-4 text-gold" data-id="element-88" />
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-warm-dark leading-tight mb-6" data-id="element-89">
          Terminación nivel estudio: dominá preparación, estructura y torno para
          sets más prolijos, duraderos y cobrables
        </h1>

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm md:text-base text-warm-muted font-medium" data-id="element-90">
          <span className="flex items-center gap-1.5" data-id="element-91">
            <CheckIcon data-id="element-92" /> 45 clases 100% online
          </span>
          <span className="hidden md:inline text-gold" data-id="element-93">•</span>
          <span className="flex items-center gap-1.5" data-id="element-94">
            <CheckIcon data-id="element-95" /> acceso de por vida + actualizaciones
          </span>
          <span className="hidden md:inline text-gold" data-id="element-96">•</span>
          <span className="flex items-center gap-1.5" data-id="element-97">
            <CheckIcon data-id="element-98" /> certificado avalado
          </span>
        </div>
      </div>
    </SectionWrapper>;
}
function CheckIcon() {
  return <svg className="w-4 h-4 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-99">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-100" />
    </svg>;
}